angular.module('content.widgets.LOWidgetService', [
])

/**
 * The LOWidgetService service handles scoring and
 * feedback for the state.learningOutcomes type
 *
 * @class LOWidgetService
 * @constructor
 * @module content.widgets.LOWidgetService
 */
.factory('LOWidgetService', [
  'ModelsService',
  'StatesService',
  function (ModelsService, StatesService) {
    'use strict';

    var service = {

      /**
       * Returns the model from the form/editor service
       *
       * @param {Object} model - model
       * @param {Object} form - form
       * @return {Object} Widget model
       */
      getModel: function getModel(model, form) {
        // make a deep clone of the model
        var newModel = _.cloneDeep(model);

        newModel.label = form.title;

        // add uuid if none present
        _.forEach(form.list, function (lo) {
          lo.id = lo.id ? lo.id : 'lo-' + uuid.v1();
        });
        newModel.content.decisions.content.stem = JSON.stringify(form.list);
        newModel.content.decisions.content.media = form.media;
        newModel.content.rules.content.decision.multiple = false;
        newModel.content.decisions.content.multiple = false;
        newModel.content.rules.content.scored = true;
        newModel.content.decisions.content.scored = true;
        newModel.content.rules.content.decision.maxAttempts = 1;
        newModel.content.rules.content.decision.correctTarget = form.choices[0].target;
        newModel.content.rules.content.decision.incorrectTarget = form.choices[0].target;
        newModel.content.rules.content.decision.choices[0].target = form.choices[0].target;
        newModel.content.rules.content.decision.choices[0].points = form.choices[0].points;
        newModel.content.decisions.content.choices[0].points = form.choices[0].points;
        newModel.content.decisions.content.choices[0].label = form.choices[0].value;
        newModel.content.rules.content.totalPoints = form.choices[0].points;

        return newModel;
      },

      /**
       * Configures the properties for the form editing process
       *
       * @param {Object} model - Model object
       * @return {Object} Form model object
       */
      configureForm: function configureForm(model) {
        var form = { schema: {}, form: {}, model: {} };
        var config = ModelsService.find('schemas', 'label', 'state.learningOutcomes');

        // make a deep clone of the model
        var modelCopy = _.cloneDeep(model);

        form.schema = config.content.schema;
        form.form = service.addStatesListToForm(config.content.form);

        // set items individually to determine format
        form.model.title = modelCopy.label;
        if (model.content.decisions.content.stem) {
          form.model.list = JSON.parse(modelCopy.content.decisions.content.stem);
        } else {
          form.model.list = [];
        }
        form.model.media = modelCopy.content.decisions.content.media;
        form.model.multiple = modelCopy.content.rules.content.decision.multiple;
        form.model.model = modelCopy.content.rules.content.decision.model;
        form.model.scored = modelCopy.content.rules.content.decision.scored;
        form.model.maxAttempts = modelCopy.content.rules.content.decision.maxAttempts;
        form.model.correctFeedback = modelCopy.content.rules.content.decision.correctFeedback;
        form.model.incorrectFeedback = modelCopy.content.rules.content.decision.incorrectFeedback;
        form.model.correctTarget = modelCopy.content.rules.content.decision.correctTarget;
        form.model.incorrectTarget = modelCopy.content.rules.content.decision.incorrectTarget;
        form.model.choices = [];

        _.forEach(modelCopy.content.rules.content.decision.choices, function (choice, index) {
          var entry = {};
          entry.points = choice.points;
          entry.target = choice.target;
          entry.correct = choice.correct;
          entry.feedback = choice.feedback;
          entry.incorrectFeedback = choice.incorrectFeedback;
          entry.correctFeedback = choice.correctFeedback;
          entry.value = modelCopy.content.decisions.content.choices[index].label;

          form.model.choices.push(entry);
        });

        return form;
      },

      /**
       * Returns a form with the StateListTitleMap variable
       * replaced with correct data
       *
       * @param {Array<Object>} form - Form collection
       * @return {Array<Object>} form
       */
      addStatesListToForm: function addStatesListToForm(form) {
        var reg = new RegExp(/\["StateListTitleMap"\]/, 'g');
        var map = JSON.stringify(StatesService.getStatesListTitleMap());

        return JSON.parse(JSON.stringify(form).replace(reg, map));
      }
    };

    return service;
  }
]);
